export default "__VITE_ASSET__CzBiC7c0__"